import { render, staticRenderFns } from "./TabShipmentPlanning.vue?vue&type=template&id=6ff2989e&scoped=true"
import script from "./TabShipmentPlanning.vue?vue&type=script&lang=js"
export * from "./TabShipmentPlanning.vue?vue&type=script&lang=js"
import style0 from "./TabShipmentPlanning.vue?vue&type=style&index=0&id=6ff2989e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2989e",
  null
  
)

export default component.exports